export const qaNotes = {
  qaNoteUpdateSuccess: "QA note updated"
};
